import { render, staticRenderFns } from "./leader_uid.vue?vue&type=template&id=1535a78b&"
import script from "./leader_uid.vue?vue&type=script&lang=js&"
export * from "./leader_uid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports